import React from "react";

import { clsx } from "clsx";

import { withFocusRing } from "../FocusRing/FocusRing";

export const SkipLink = withFocusRing(
  (
    props: React.DetailedHTMLProps<
      React.AnchorHTMLAttributes<HTMLAnchorElement>,
      HTMLAnchorElement
    >,
  ) => (
    <a
      {...props}
      href="#content-main"
      className={clsx(
        props.className,
        "px-3 fixed -left-peta -top-peta z-100 bg-warning py-midi text-white focus:left-midi focus:top-midi focus-visible:!outline-warning",
      )}
    >
      Skip Navigation
    </a>
  ),
);
